export default __webpack_public_path__ + "static/media/detox2.d579edd8.jpg";